import React from 'react';
import { ThemeStaticContent } from '@hotelplan/graphql.types';
import PageLead from 'components/core/page-lead/PageLead';
import useSearchParam from 'components/core/search/useSearchParam';
import { useMetaIndexTag } from 'components/domain/meta';

export interface IThemePageLeadProps
  extends Pick<ThemeStaticContent, 'information' | 'hero' | 'disrupterObject'> {
  children?: React.ReactElement | React.ReactElement[];
}

const ThemePageLead: React.FC<IThemePageLeadProps> = ({
  information,
  disrupterObject,
  hero,
  children,
}: IThemePageLeadProps): React.ReactElement => {
  const searchParam = useSearchParam();
  const indexed = !Boolean(searchParam);

  const metaTag = useMetaIndexTag({ indexed });

  return (
    <>
      {metaTag}
      <PageLead
        title={information?.title}
        text={information?.text}
        hero={hero}
        addBorderBottom={true}
        disrupterObject={disrupterObject}
      >
        {children}
      </PageLead>
    </>
  );
};

export default ThemePageLead;
